import { render } from "./PopupWalletTkzBuy.vue?vue&type=template&id=4f6cf6e1&scoped=true"
import script from "./PopupWalletTkzBuy.vue?vue&type=script&lang=js"
export * from "./PopupWalletTkzBuy.vue?vue&type=script&lang=js"

import "./PopupWalletTkzBuy.vue?vue&type=style&index=0&id=4f6cf6e1&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6cf6e1"]])

export default __exports__